export default "__VITE_ASSET__CwX3sEqG__"